import { render, staticRenderFns } from "./WrapperTab.vue?vue&type=template&id=2164d6f0&scoped=true&"
import script from "./WrapperTab.vue?vue&type=script&lang=js&"
export * from "./WrapperTab.vue?vue&type=script&lang=js&"
import style0 from "./WrapperTab.vue?vue&type=style&index=0&id=2164d6f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164d6f0",
  null
  
)

export default component.exports